// extracted by mini-css-extract-plugin
module.exports = {"selectionTab":"SelectionTab-module--selection-tab--3C6Wi"};